import React from 'react';
import { compose, graphql, withApollo } from 'react-apollo';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import {
  findDashboardTitleImage,
  saveDashboardImage,
} from '../schema/dashboardImage-schema.graphql';
import { withSnackbar } from '../../snackbar/SnackbarContext';
import StayCurrentPortrait from '@material-ui/icons/StayCurrentPortrait';
import s from './Dashboard.module.less';
import cs from 'classnames';
import StatusBar from './StatusBar';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import localization from '../../../i18n/localization';
import Typography from '@material-ui/core/Typography';
import Button from 'components/CustomButtons/Button.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';

const MAX_FILE_SIZE = 921600;

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  header: {
    backgroundColor: '#263237',
    backgroundSize: 'cover',
  },
  marginBottom10: {
    marginBottom: '10px',
  },
  separator: {
    height: '50px',
    marginBottom: '30px',
  },
  smallInputLabel: {
    position: 'relative',
    fontSize: '10px',
    marginTop: '-34px',
  },
  divCenter: {
    textAlign: 'center',
  },
  label: {
    marginTop: 0,
  },
});

const foreignObjectStyle = {
  viewportX: 23,
  viewportY: 86,
  viewportWidth: 302,
  headerLargeHeight: 200,
};

class DashboardTitleImage extends React.Component {
  constructor(props) {
    super(props);
    this.changeImage = this.changeImage.bind(this);
    this.fileInput = React.createRef();
    this.state = {
      image: {
        filename: '',
        mimetype: '',
        data: '',
      },
      file: null,
      inputKey: Date.now(),
    };
  }

  componentDidMount() {
    this.getDashboardTitleImage();
  }

  renderHeader = () => {
    return (
      <div>
        <StatusBar />
      </div>
    );
  };

  getDashboardTitleImage = async () => {
    const { client } = this.props;

    const { data } = await client.query({
      query: findDashboardTitleImage,
    });

    this.setState(prevState => ({
      ...prevState,
      image: data.image,
      file: null,
      inputKey: Date.now(),
    }));
  };

  isValidFile(file) {
    const { addNotification } = this.props;
    let res = true;

    if (!file) {
      addNotification('danger', localization.de.app.SELECT_FILE_WANING_MESSAGE);
      res = false;
    }
    if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
      addNotification(
        'danger',
        localization.de.app.SELECT_CORRECT_FILE_WANING_MESSAGE
      );
      res = false;
    }
    if (file.size > MAX_FILE_SIZE) {
      addNotification('danger', localization.de.app.FILE_TOO_LARGE);
      res = false;
    }

    return res;
  }

  changeImage(e) {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];

    if (!this.isValidFile(file)) {
      this.setState(prevState => ({
        ...prevState,
        file: null,
        inputKey: Date.now(),
      }));

      return;
    }

    reader.onloadend = () => {
      this.setState(prevState => ({
        ...prevState,
        file: {
          name: file.name,
          type: file.type,
          data: reader.result,
        },
      }));
    };
    reader.readAsDataURL(file);
  }

  saveImage = async e => {
    const { addNotification, saveDashboardImage } = this.props;

    try {
      if (!this.isValidFile(this.state.file)) {
        return;
      }

      const { data } = await saveDashboardImage({
        variables: {
          file: {
            filename: this.state.file.name,
            mimetype: this.state.file.type,
            data: this.state.file.data,
          },
        },
      });

      if (!data.image) {
        addNotification('danger', 'Unerwarteter Fehler aufgetreten');
        return;
      }

      this.setState(prevState => ({
        ...prevState,
        image: data.image,
        file: null,
        inputKey: Date.now(),
      }));

      addNotification('success', localization.de.app.OPERATION_SUCCESS);
    } catch (e) {
      console.log(e);
      addNotification('danger', 'Unerwarteter Fehler aufgetreten');
    }
  };

  render() {
    const { classes } = this.props;
    const { image, file } = this.state;

    return (
      <div className={classes.root}>
        <Card>
          <CardHeader icon stats>
            <CardIcon color="rose">
              <StayCurrentPortrait />
            </CardIcon>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={4} md={4} lg={4}>
                <div className={classes.divCenter}>
                  <svg
                    width="250"
                    height="500"
                    className={cs(s.base, this.props.className)}
                    viewBox="0 0 348 710"
                  >
                    <path
                      className={s.body}
                      d="M345.897436,150.542406 L346.505018,150.542406 C347.323035,150.542406 347.998028,151.214437 347.998028,152.043429 L347.998028,201.556177 C347.998028,202.393218 347.329585,203.057199 346.505018,203.057199 L345.897436,203.057199 L345.897436,635.003991 C345.897436,676.42606 312.32044,710 270.901116,710 L77.0969113,710 C35.6716145,710 2.10059172,676.423143 2.10059172,635.003991 L2.10059172,267.475345 L1.4930093,267.475345 C0.6749928,267.475345 0,266.803315 0,265.974323 L0,216.461574 C0,215.624533 0.668443033,214.960552 1.4930093,214.960552 L2.10059172,214.960552 L2.10059172,203.057199 L1.4930093,203.057199 C0.6749928,203.057199 0,202.385169 0,201.556177 L0,152.043429 C0,151.206387 0.668443033,150.542406 1.4930093,150.542406 L2.10059172,150.542406 L2.10059172,118.333333 L1.4930093,118.333333 C0.6749928,118.333333 0,117.660394 0,116.830282 L0,91.128298 C0,90.3065731 0.668443033,89.6252465 1.4930093,89.6252465 L2.10059172,89.6252465 L2.10059172,74.9960094 C2.10059172,33.5739401 35.6775877,0 77.0969113,0 L270.901116,0 C312.326413,0 345.897436,33.5768571 345.897436,74.9960094 L345.897436,150.542406 Z M23,86 L23,622 L325,622 L325,86 L23,86 Z M173.648915,688.293886 C188.343829,688.293886 200.25641,676.381304 200.25641,661.686391 C200.25641,646.991477 188.343829,635.078895 173.648915,635.078895 C158.954001,635.078895 147.04142,646.991477 147.04142,661.686391 C147.04142,676.381304 158.954001,688.293886 173.648915,688.293886 Z M173.648915,685.493097 C160.500834,685.493097 149.842209,674.834471 149.842209,661.686391 C149.842209,648.53831 160.500834,637.879684 173.648915,637.879684 C186.796996,637.879684 197.455621,648.53831 197.455621,661.686391 C197.455621,674.834471 186.796996,685.493097 173.648915,685.493097 Z M119.033531,50.4142012 C122.127197,50.4142012 124.635108,47.9062893 124.635108,44.8126233 C124.635108,41.7189572 122.127197,39.2110454 119.033531,39.2110454 C115.939865,39.2110454 113.431953,41.7189572 113.431953,44.8126233 C113.431953,47.9062893 115.939865,50.4142012 119.033531,50.4142012 Z M174.349112,25.9072978 C176.282654,25.9072978 177.850099,24.3398529 177.850099,22.4063116 C177.850099,20.4727704 176.282654,18.9053254 174.349112,18.9053254 C172.415571,18.9053254 170.848126,20.4727704 170.848126,22.4063116 C170.848126,24.3398529 172.415571,25.9072978 174.349112,25.9072978 Z M149.138219,42.0118343 C147.593481,42.0118343 146.341223,43.2689377 146.341223,44.8126233 C146.341223,46.3594563 147.58973,47.6134122 149.138219,47.6134122 L199.560006,47.6134122 C201.104744,47.6134122 202.357002,46.3563088 202.357002,44.8126233 C202.357002,43.2657902 201.108495,42.0118343 199.560006,42.0118343 L149.138219,42.0118343 Z"
                    />
                    <image
                      x={23}
                      y={120}
                      width={301}
                      xlinkHref={file ? file.data : image.data}
                    />
                    <foreignObject
                      x={foreignObjectStyle.viewportX}
                      y={foreignObjectStyle.viewportY}
                      width={foreignObjectStyle.viewportWidth}
                      height={foreignObjectStyle.headerLargeHeight}
                    >
                      <div className={classes.header}>
                        <StatusBar />
                      </div>
                    </foreignObject>
                  </svg>
                  <br />
                  <InputLabel className={classes.smallInputLabel}>
                    {localization.de.app.IPHONE_MODEL}
                  </InputLabel>
                </div>
              </GridItem>
              <GridItem xs={12} sm={8} md={8} lg={8}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Typography variant="subtitle1" color="textSecondary">
                      {localization.de.app.FILES}
                    </Typography>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6} lg={6}>
                    <FormControl fullWidth={true}>
                      <InputLabel
                        htmlFor={localization.de.app.FILENAME}
                        className={classes.inputLabel}
                      >
                        {localization.de.app.FILENAME}
                      </InputLabel>
                    </FormControl>
                    <FormControl fullWidth={true}>
                      <CustomInput
                        inputProps={{
                          value: image.filename,
                          disabled: true,
                        }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6} lg={6}>
                    <FormControl fullWidth={true}>
                      <InputLabel
                        htmlFor={localization.de.app.MIMETYPE}
                        className={classes.inputLabel}
                      >
                        {localization.de.app.MIMETYPE}
                      </InputLabel>
                    </FormControl>
                    <FormControl fullWidth={true}>
                      <CustomInput
                        inputProps={{ value: image.mimetype, disabled: true }}
                        formControlProps={{
                          fullWidth: true,
                        }}
                      />
                    </FormControl>
                  </GridItem>
                </GridContainer>
                <div className={classes.separator} />
                <form onSubmit={this.saveImage}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="subtitle1" color="textSecondary">
                        {localization.de.app.NEW_FILE}
                      </Typography>
                      <div className={classes.marginBottom10} />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <FormControl fullWidth={true}>
                        <InputLabel
                          htmlFor={localization.de.app.FILE}
                          className={classes.inputLabel}
                          style={styles.label}
                        >
                          {localization.de.app.FILE}
                        </InputLabel>
                      </FormControl>
                      <FormControl fullWidth={true}>
                        <CustomInput
                          inputProps={{
                            type: 'file',
                            onChange: this.changeImage,
                            key: this.state.inputKey,
                          }}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        <InputLabel
                          htmlFor={localization.de.app.FILE}
                          className={classes.smallInputLabel}
                        >
                          {localization.de.app.INPUT_FILE_LABEL}
                        </InputLabel>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                  <div className={classes.marginBottom10} />
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12} lg={12}>
                      <Button
                        type="submit"
                        style={{ marginTop: 40 }}
                        color="info"
                      >
                        {localization.de.app.SAVE}
                      </Button>
                      <Clearfix />
                    </GridItem>
                  </GridContainer>
                </form>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </div>
    );
  }
}

DashboardTitleImage.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const enhance = compose(
  graphql(saveDashboardImage, { name: 'saveDashboardImage' }),
  withStyles(styles),
  withSnackbar,
  withApollo
);

export default enhance(DashboardTitleImage);



// WEBPACK FOOTER //
// ./src/views/app/components/DashboardImage.jsx